import React from 'react';

import styles from './CompetitionNotes.module.css';

type TProps = {
  children: React.ReactNode;
};

export const CompetitionNotesWrapper = ({ children }: TProps) => {
  return <div className={styles.CompetitionNotes__Wrapper}>{children}</div>;
};
